export default __webpack_public_path__ + "static/media/brush.fa163c98.svg";